'use strict'

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

$('a[href^="#"]'+'a[href!="#"]').each(
  ()->
    if not $(this).closest('.js-anchor').length
      $(this).on('click.smoothScroll'
        (e)->
          e.preventDefault()

          $(
            if (navigator.userAgent.indexOf('Opera') isnt -1)
            then (
              if document.compatMode is 'BackCompat'
              then 'body'
              else 'html'
            )
            else 'html,body'
          ).animate({
            scrollTop:$($(this).attr('href')).offset().top - $('.p-header__nav').outerHeight() - 20
          },{
            easing:'easeInOutCirc',
            duration:1000
          })

          return
      )
)

if location.hash isnt ''
  $(
    if (navigator.userAgent.indexOf('Opera') isnt -1)
    then (
      if document.compatMode is 'BackCompat'
      then 'body'
      else 'html'
    )
    else 'html,body'
  ).animate({
    scrollTop:$(location.hash).offset().top - $('.p-header__nav').outerHeight() - 20
  },{
    easing:'easeInOutCirc',
    duration:1
  })
